/* istanbul ignore file -- legacy paymentagent transfer/withdraw and cashier WS calls, superseded by the v4 REST wallet/payment-agent endpoints in DerivREST.js */
import { stripLoginId } from '../utils';
let _reqId = 1; const getUniqueId = () => _reqId++;


export const getCashierLockStatus = () => ({
    cashier_password: 1,
});

export const setCashierLock = (options) => ({
    cashier_password: 1,
    ...stripLoginId(options),
});

export const withdrawToPaymentAgent = (options) => ({
    paymentagent_withdraw: 1,
    ...stripLoginId(options),
});

export const paymentAgentTransfer = (options) => ({
    paymentagent_transfer: 1,
    ...stripLoginId(options),
});

export const transferBetweenAccounts = (options) => ({
    transfer_between_accounts: 1,
    ...stripLoginId(options),
});
